import { createCommand, LexicalCommand } from 'lexical';

export const INSERT_SLOT_COMMAND: LexicalCommand<{ slotName: string }> =
  createCommand('INSERT_SLOT_COMMAND');
